export default "__VITE_ASSET__da01bfcf__"